import Spinner from "components/Spinner";
import { setNotification } from "features/Notification/notificationSlice";
import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { useDispatch } from "react-redux";
import authHeader from "services/auth-header";
import API from "services/axios";

export default function SelectMaterialLot({
  refresh,
  setRefresh,
  resultHeight,
  selectedMaterialId,
  selectedPurchaseLot,
  setSelectedPurchaseLot,
  purchaseHistory,
  setPurchaseHistory,
  setShowMaterialModal,
}) {
  /*   All States
   ********************************************* */
  const dispatch = useDispatch();

  const [searchText, setSearchText] = useState("");
  const [searchFilterBy, setSearchFilterBy] = useState(null);
  const [searchResults, setSearchResults] = useState(null);
  const [loading, setLoading] = useState(null);

  /*   All Functions
   ********************************************* */
  const fetchPurchaseHistory = async () => {
    try {
      setLoading(true);

      const { data } = await API.get(
        "/manufacturer-issues/purchases/" + selectedMaterialId,
        {
          headers: authHeader(),
        }
      );
      if (data?.success) {
        setPurchaseHistory(data?.data);
      }
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    } finally {
      setLoading(false);
    }
  };

  let TableBody = ({ purchase }) => {
    return (
      <tr
        className={`${
          selectedPurchaseLot?.id === purchase.id && "bg-primary bg-opacity-10"
        } `}
        key={purchase.id}
      >
        <td className="align-middle py-1 ">{purchase.styleId}</td>
        <td className="align-middle py-1 ">{purchase.lotId}</td>
        <td className="align-middle py-1 ">
          {purchase.m_vendor?.name?.length > 20
            ? `${purchase.m_vendor?.name?.slice(0, 20)}...`
            : `${purchase.m_vendor?.name}`}
        </td>
        <td className="align-middle py-1 ">{purchase.m_materialList?.color}</td>
        <td className="align-middle py-1 ">{purchase.qty}</td>
        <td className="align-middle py-1 ">
          <button
            className="btn btn-sm  btn-primary"
            onClick={() => setSelectedPurchaseLot(purchase)}
          >
            Select
          </button>
        </td>
      </tr>
    );
  };

  const resetAll = () => {
    setSearchText("");
    setSearchResults(null);
    setSearchFilterBy(null);
    setSelectedPurchaseLot(null);
  };

  /*   All UseEffects
   ********************************************* */
  useEffect(() => {
    let timeout = setTimeout(() => {
      if (selectedMaterialId) {
        fetchPurchaseHistory();
      }
    }, 50);
    return () => clearTimeout(timeout);
  }, [selectedMaterialId]);

  useEffect(() => {
    async function refreshPurchaseHistory() {
      if (refresh && selectedMaterialId) {
        await fetchPurchaseHistory();
        setRefresh(false);
      }
    }
    refreshPurchaseHistory();
  }, [refresh, selectedMaterialId]);

  useEffect(() => {
    // Search across all fields
    if (searchText === "") {
      setSearchResults(null);
      return;
    }
    const searchResults = purchaseHistory.filter((lot) => {
      const searchTextLower = searchText.toLowerCase();

      const styleId = lot.styleId ? lot.styleId.toLowerCase() : "";
      const lotId = lot.lotId ? lot?.lotId?.toString()?.toString() : "";
      const color = lot?.m_materialList?.color
        ? lot?.m_materialList?.color?.toLowerCase()
        : "";
      const qty = lot?.qty ? lot?.qty?.toString().toLowerCase() : "";

      // check if search filter by is selected
      if (searchFilterBy) {
        if (searchFilterBy === "qty") {
          return qty.includes(searchTextLower);
        } else if (searchFilterBy === "color") {
          return color.includes(searchTextLower);
        } else if (searchFilterBy === "lotId") {
          return lotId.includes(searchTextLower);
        } else if (searchFilterBy === "styleId") {
          return styleId.includes(searchTextLower);
        }
      }

      return (
        qty.includes(searchTextLower) ||
        styleId.includes(searchTextLower) ||
        color.includes(searchTextLower) ||
        lotId.includes(searchTextLower)
      );
    });

    setSearchResults(searchResults);
  }, [searchText, purchaseHistory]);

  return (
    <div className="bg-light bg-opacity-75 custom-shadow-sm px-3 py-2 rounded-3 h-100">
      <div className="">
        <div className="d-flex align-items-center justify-content-between">
          <h4 className="mb-2">Select Purchase Lot</h4>
          <div>
            <button onClick={resetAll} className="btn btn-sm btn-danger">
              Clear
            </button>
          </div>
        </div>
      </div>
      <div className="">
        {/* Search */}
        <div className="d-flex align-items-center gap-2 mb-3 mt-2">
          {/* Filter By */}
          <Dropdown>
            <Dropdown.Toggle>
              {searchFilterBy
                ? searchFilterBy.charAt(0).toUpperCase() +
                  searchFilterBy.slice(1)
                : "Filter By"}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item onClick={() => setSearchFilterBy(null)}>
                All
              </Dropdown.Item>
              <Dropdown.Item onClick={() => setSearchFilterBy("styleId")}>
                Style Id
              </Dropdown.Item>
              <Dropdown.Item onClick={() => setSearchFilterBy("lotId")}>
                Lot Id
              </Dropdown.Item>
              <Dropdown.Item onClick={() => setSearchFilterBy("color")}>
                Color
              </Dropdown.Item>
              <Dropdown.Item onClick={() => setSearchFilterBy("qty")}>
                Qty
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          <input
            type="text"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            placeholder="Search Purchase Lot"
            className="form-control w-100"
          />
        </div>

        {/* Selected Purchase Lot */}
        {selectedPurchaseLot && (
          <>
            <div className="mt-3 bg-success bg-opacity-25  px-2 rounded-3 d-flex align-items-center justify-content-between">
              <h4 className="">Selected </h4>
              <div className="d-flex align-items-center gap-2">
                <strong>Style Id:</strong> {selectedPurchaseLot?.styleId}
                <strong>Color:</strong> {selectedPurchaseLot?.qty}
                <strong>Color:</strong>{" "}
                {selectedPurchaseLot?.m_materialList?.color}
              </div>
              <div>
                {/* Delete */}
                <button
                  className="btn btn-sm px-1 py-0 btn-danger"
                  onClick={() => setSelectedPurchaseLot(null)}
                >
                  <i className="mdi mdi-delete"></i>
                </button>
              </div>
            </div>
          </>
        )}

        {/* Material List */}
        <h4 className="mt-3">Purchase Lot List</h4>
        {loading && <Spinner />}

        {selectedMaterialId ? (
          <>
            {/* Table */}
            {purchaseHistory?.length > 0 ? (
              <div
                className="table-responsive bg-white flex-grow-1"
                style={{
                  overflowY: "auto",
                  maxHeight: resultHeight
                    ? selectedPurchaseLot
                      ? `calc( ${resultHeight} - 6vh )`
                      : resultHeight
                    : selectedPurchaseLot
                    ? "64vh"
                    : "70vh",
                }}
              >
                <table className="table table-bordered table-hover ">
                  <thead>
                    <tr>
                      <th className="text-nowrap">Style Id</th>
                      <th className="text-nowrap">Lot Id</th>
                      <th className="w-100">Vendor</th>
                      <th>Color</th>
                      <th> Qty</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody className="">
                    {!searchResults && purchaseHistory ? (
                      purchaseHistory.map((purchase) => (
                        <TableBody key={purchase.id} purchase={purchase} />
                      ))
                    ) : (
                      <>
                        {searchResults?.length > 0 ? (
                          searchResults.map((purchase) => (
                            <TableBody key={purchase.id} purchase={purchase} />
                          ))
                        ) : (
                          <tr>
                            <td colSpan={5} className="text-center">
                              No Purchase Lot Found
                            </td>
                          </tr>
                        )}
                      </>
                    )}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="text-center mt-5">
                <h5>No Purchase Lot Found</h5>
              </div>
            )}
          </>
        ) : (
          <div className="text-center mt-5">
            <h3 className="text-danger">Please Select a Material First</h3>
          </div>
        )}
      </div>
    </div>
  );
}
